<template>
  <span>
    <span :class="styles" />
  </span>
</template>

<script>
import { WholeReportModel } from '@/models/Dashboard'

export default {
  name: 'ServeStatusIndicator',
  props: {
    value: {
      required: true,
      validator: value => {
        return (
          Object.values(WholeReportModel.ServeStatusList).indexOf(value) !== -1
        )
      },
    },
  },
  computed: {
    styles() {
      if (!this.value) return
      return [
        'indicator',
        `is${this.value.charAt(0).toUpperCase()}${this.value.slice(1)}`,
      ]
    },
  },
}
</script>

<style scoped lang="scss">
.indicator {
  display: inline-block;
  height: 15px;
  width: 15px;
  border: 1px solid transparent;
  border-radius: 50%;

  &.isWarning {
    background-color: red;
    border-color: darken(red, 5%);
  }

  &.isCaution {
    background-color: yellow;
    border-color: darken(yellow, 5%);
  }

  &.isRunRate {
    background-color: white;
    border-color: darken(white, 10%);
  }

  &.isNotServe {
    background-color: grey;
    border-color: darken(grey, 5%);
  }
}
</style>
